
(function () {
  let prevColor = window.currentColor
  const isMobile = document.documentElement.clientWidth <= 991
  const product_gallery = document.querySelector('.product_gallery')
  let product_slider = product_gallery.querySelector('.product__images__slider')
  if (!product_slider) {
    validateOldGallery()
    return
  }
  let product_slider_width = product_slider.offsetWidth
  let product_slider__dots = product_gallery.querySelector('.product__images__dots')

  if (isMobile) {
    mobileSwatchesListener()
    destroyZoomImages()
  } else {

    validateZoomImages()
  }
  document.querySelectorAll('.js-section-product-single .option-label_color li').forEach(swatch => {
    swatch.addEventListener('click', () => {
      // const color = swatch.dataset.option_value
      const color = swatch.getAttribute('data-option_value').toLowerCase().replace(' / ', '-').replace(/\ /g, '-').replace('/', '-')

      if (color === prevColor) { return }

      prevColor = color
      product_gallery.querySelector('.product__images__slider').classList.add('loading')
      setTimeout(() => {
        updateGalleryByEndPoint(color)
      }, 150)
    })
  })

  function validateOldGallery () {
    var $sliderPrimary = $('.js-slider-primary');
    $sliderPrimary.each(function () {
      var $sliderImages = $(this).find('.slider__slides');

      $sliderImages.on('init', function (slick) {
        zoomElement($sliderImages.find('.slider__slide-image'), '.slider__slide', 'slider__slide--zoomed');
      });
    })
  }

  function mobileSwatchesListener () {
    function updateSwatches() {
      const horizontal = product_slider.scrollLeft
      product_slider__dots.querySelectorAll('.product__image__dot').forEach((dot, index) => {
      const ratio = Math.round(horizontal / product_slider_width)

        index === ratio
          ? dot.classList.add('active')
          : dot.classList.remove('active')
      })
    }

    function debounce(cb, delay = 1000) {
      let timeout

      return (...args) => {
        clearTimeout(timeout)
        timeout = setTimeout(() => {
          cb(...args)
        }, delay)
      }
    }

    const updateDebounceText = debounce(() => {
      updateSwatches()
    }, 150)

    product_slider.addEventListener("scroll", e => {
      updateDebounceText()
    })

    $('.product__images__slider').scrollLeft(0);
  }

  /*
  function InjectVideoOnGallery(color) {
    if (window.PDP_VIDEOS) {
      const currentVideo = window.PDP_VIDEOS.find(video => video.color === color)
      if (!currentVideo) { return }

      const position = currentVideo.position && currentVideo.position != '0'
        ? parseInt(currentVideo.position) - 1
        : 0

      const videoDOM = `
        <div class="product__image product__image--video ${ position < 2 ? 'product__image--large' : ''}">
          <span>
            <iframe src="https://player.vimeo.com/video/${currentVideo.id}?autoplay=1&amp;loop=1&amp;muted=1&amp;background=1&amp;title=0&amp;byline=0&amp;portrait=0&amp;quality=720p" width="640" height="889" frameborder="0" allow="autoplay; fullscreen" allowfullscreen=""></iframe>
          </span>
        </div>`

      const targetCard = product_gallery.querySelectorAll('.product_gallery .product__image')[position]
      targetCard.insertAdjacentHTML('beforebegin', videoDOM)

      if (isMobile) {
        const targetDot = product_slider__dots.querySelectorAll('.product__image__dot')[position]
        const dotDOM = `<button class="product__image__dot ${position == 0 ? 'active' : ''}"></button>`
        targetDot.insertAdjacentHTML('beforebegin', dotDOM)
      }
    }
  }
  InjectVideoOnGallery(currentColor);
  */

  function validateZoomImages () {
    if (!$('.js-section-product-single .product__image span').find('.zoomImg').length) {
      $(document).off('mouseover', '.js-section-product-single .product__image span');
      $(document).on('mouseover', '.js-section-product-single .product__image span', function (event) {
        const $this = $(this);
        if ($this.find('.zoomImg').length === 0) {
          zoomElement($(this), '.product__image', 'product__image--zoomed', $this.find('img').data('zoom-image'));
        }
      });
    }
  }

  function destroyZoomImages () {
    $('.js-section-product-single .product__image').trigger('zoom.destroy');
  }


  function zoomElement($element, $parent, className, zoomImage = false) {
    $element.zoom({
      on: 'click',
      url: zoomImage,
      onZoomIn: function () {
        $(this).closest($parent).addClass(className);
        $(this).one('mouseleave', function () {
          $(this).trigger('click');
        });
      },
      onZoomOut: function () {
        $(this).closest($parent).removeClass(className);
        $(this).unbind('mouseleave');
      },
    });
  }

  function replaceUrlParam(variant, color) {
    const newurl = `${window.location.protocol}//${window.location.host}${window.location.pathname}?variant=${variant}&color=${color}`;
    window.history.replaceState({path: newurl}, '', newurl);
  }

  function updateGalleryByEndPoint (color) {
    const handle = product_gallery.dataset.productHandle;
    const variantId = $('#variant_selector').val();
    if (handle && variantId) {
      fetchGalleryJSON(handle, variantId).then(media => {
        product_gallery.querySelector('.product__images__js').innerHTML = media

        setTimeout(() => {
          product_slider = product_gallery.querySelector('.product__images__slider')
          product_slider_width = product_slider.offsetWidth
          product_slider__dots = product_gallery.querySelector('.product__images__dots')
          product_slider.classList.remove('loading')
          // InjectVideoOnGallery(color)

          if (!isMobile) { return }
          setTimeout(() => {
            mobileSwatchesListener()
          }, 150)
        }, 150)
        setTimeout(() => {
      });

        replaceUrlParam(variantId, color)
      }, 150)
    }
  }

  async function fetchGalleryJSON(handle, variantId) {
    const response = await fetch(`/products/${handle}?variant=${variantId}&view=colors-endpoint`);
    const media = await response.text();
    return media;
  }
})();
